import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FrequencyService } from '../services/frequency.service';
import { Frequency } from '../models/frequency.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-frequency-form',
  templateUrl: './frequency-form.component.html'
})
export class FrequencyFormComponent {
  constructor(public service: FrequencyService, private notificationService: NotificationService) { }

  @Input() model: Frequency;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  ngOnInit() {
    //this.notificationService.showDatePicker();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.frequencyID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }


}

